import React from 'react';
import PropTypes from 'prop-types';
import { getFares } from '../../../_integrations/everymundo/package';
import PackagesCarouselSkeleton from '../../others/Skeleton/SkeletonPackagesCarousel';
import FaresCarouselBackgroundImageContainer from '../FaresCarouselBackgroundImageContainer';

const PackagesCarouselContainer = (props) => (
  <FaresCarouselBackgroundImageContainer
    SkeletonInstance={PackagesCarouselSkeleton}
    {...props}
    getFares={getFares}
  />
);

PackagesCarouselContainer.componentName = 'PackagesCarouselContainer';

PackagesCarouselContainer.propTypes = {
  /**
   * Parameters tracking
   */
  tracking: PropTypes.objectOf(PropTypes.any)
};

PackagesCarouselContainer.defaultProps = {
  tracking: {
    flexibleDates: false,
    passengerCount: 1,
    promoCode: 'EVERYMUNDO',
    eventType: 'packagesCarouselContainer'
  }
};

export default PackagesCarouselContainer;
